import { HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { AxiosHeaders, AxiosRequestConfig } from 'axios';
import {
  CreateFiatDepositModel,
  DepositReponseAssetModel,
  DepositReponseModel,
} from 'models/deposit';
import { getLocalStorage } from 'utils/sessionStorage';

const depositApi = {
  getAddress: (
    headers: AxiosRequestConfig<AxiosHeaders>,
    assetId: number,
  ): Promise<HttpResponse<DepositReponseModel>> => {
    const url = `/wallet/api/deposit/${assetId}/address`;
    return handleRequest(axiosClient.get(url, headers));
  },
  getAddresses: (): Promise<HttpResponse<DepositReponseAssetModel[]>> => {
    const url = `/wallet/api/deposit`;
    return handleRequest(
      axiosClient.get(url, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  createFiatDeposit: (
    request: CreateFiatDepositModel,
  ): Promise<HttpResponse<DepositReponseModel>> => {
    const url = `/wallet/api/fiat-deposits`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
};

export default depositApi;
